"use client";

import React from "react";
import { LeadFormIntegratedProps } from "./LeadFormIntegrated.types";
import { Default } from "./variations/Default";
import { Stepper } from "./variations/Stepper";

export const LeadFormIntegrated: React.FC<LeadFormIntegratedProps> = (props) => {
  if (props.variation === "stepper" && props.formType === "integrated-plp") {
    return <Stepper {...props} formType="stepper" />;
  }

  return <Default {...props} />;
};
